<op-button-ng
  icon="pi pi-th-large"
  [outlined]="ghost === true ? false : true"
  [ghost]="ghost"
  (click)="disabled === true ? undefined : menu.toggle($event)"
  [disabled]="disabled"
/>

<p-menu
  #menu
  [model]="processedItems"
  [popup]="true"
  [appendTo]="'body'"
  [styleClass]="menuRootClass"
/>
